module.exports = __webpack_public_path__ + "media/yes4.b8982a66.mp3";